import cachedKeysConfig from '../cachedKeys.json';

interface CachedKeysConfig {
  localStorage: string[];
  sessionStorage: string[];
  cookies: string[];
}

const config: CachedKeysConfig = cachedKeysConfig;

/**
 * Clear cached data from browser storage.
 */
export const flushCachedData = (): void => {
  // clear localStorage keys
  config.localStorage.forEach(key => {
    if (key.trim()) {
      localStorage.removeItem(key);
    }
  });
  // clear sessionStorage keys
  config.sessionStorage.forEach(key => {
    if (key.trim()) {
      sessionStorage.removeItem(key);
    }
  });
  // clear cookies
  config.cookies.forEach(key => {
    if (key.trim()) {
      document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  });
};
